import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { applicantsApi, type ApplicationStatus } from '@/features/recruiter/api/applicants.api'

export function useApplicantsQuery(jobId: number, params: { status?: string; page?: number } = {}) {
  return useQuery({
    queryKey: ['recruiter', 'jobs', jobId, 'applicants', params],
    queryFn: () => applicantsApi.list(jobId, params),
    placeholderData: (previous) => previous,
  })
}

export function useApplicantQuery(applicationId: number | undefined) {
  return useQuery({
    queryKey: ['recruiter', 'applications', applicationId],
    queryFn: () => applicantsApi.get(applicationId as number),
    enabled: applicationId != null,
  })
}

export function useChangeApplicationStatus(jobId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      applicationId,
      status,
      notes,
      offerLetter,
    }: {
      applicationId: number
      status: ApplicationStatus
      notes?: string
      offerLetter?: File
    }) => applicantsApi.changeStatus(applicationId, status, notes, offerLetter),
    onSuccess: (_data, { applicationId }) => {
      void queryClient.invalidateQueries({ queryKey: ['recruiter', 'application-documents', applicationId] })
      void queryClient.invalidateQueries({ queryKey: ['recruiter', 'jobs', jobId, 'applicants'] })
      void queryClient.invalidateQueries({ queryKey: ['recruiter', 'applications'] })
    },
  })
}
